import { faPeopleArrows } from '@fortawesome/pro-duotone-svg-icons';
import { Dictionary } from 'lodash';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Team, TeamMeta } from 'api/models';
import { Project } from 'api/project';
import { TeamsBulkUpdateStatus } from 'api/teams';
import { EmptyState, EmptyStateIcon } from 'components/atoms/empty-state';
import { Option } from 'components/atoms/select';
import { Extra } from 'components/molecules/squad-picker';
import {
  ClickEventTags,
  useLoadLoggerForDataDog,
} from 'hooks/use-data-dog-logger';
import { PlaceholderRow } from '../placeholder-row';
import { PlaceholderValueMap } from '../types';

export interface Props {
  placeholders: Team[];
  placeholderMeta: Dictionary<TeamMeta>;
  project: Project;
  placeholderValueMap: PlaceholderValueMap;
  onPlaceholderValueChange: (placeholder: Team, value?: Option<Extra>) => void;
  readOnly: boolean;
  updateStatus?: TeamsBulkUpdateStatus[] | undefined;
}

const Wrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  min-height: 200px;
  padding-bottom: var(--spacing-07);
`;

const StyledEmptyState = styled(EmptyState)`
  margin-left: var(--spacing-06);
  margin-top: var(--spacing-06);
  color: var(--gray-50);
  margin-bottom: var(--spacing-06);
  svg {
    width: 60px;
  }
  [class^='empty-state__Message'] {
    width: 100%;
  }
`;

export const DefaultModal: FC<Props> = ({
  placeholders,
  project,
  placeholderValueMap,
  onPlaceholderValueChange,
  placeholderMeta,
  readOnly,
}) => {
  useLoadLoggerForDataDog([
    ClickEventTags.ProjectPlanPlaceholderResolutionPopup,
  ]);

  return (
    <Wrapper>
      {placeholders.length === 0 ? (
        <StyledEmptyState
          image={<EmptyStateIcon icon={faPeopleArrows} />}
          message={
            <FormattedMessage id="projects.create.team_details.placeholders.empty.message" />
          }
        />
      ) : (
        <>
          {placeholders.map((placeholder) => {
            return (
              <PlaceholderRow
                key={placeholder.teamId}
                placeholderMeta={placeholderMeta}
                placeholder={placeholder}
                project={project}
                value={placeholderValueMap[placeholder.teamId]}
                onChange={onPlaceholderValueChange}
                readOnly={readOnly}
              />
            );
          })}
        </>
      )}
    </Wrapper>
  );
};
